import classNames from 'classnames'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useRef } from 'react'
import DropdownItem from 'react-bootstrap/DropdownItem'
import { Menu, Typeahead as BSTypeahead } from 'react-bootstrap-typeahead'

import { RelatedType } from '@/types/page'

import styles from './TagsTypeahead.module.scss'

type Props = {
  related: RelatedType[]
  title: string
}

const RelatedTypeahead = ({ related, title }: Props) => {
  const router = useRouter()
  const ref = useRef<BSTypeahead<any>>(null)
  return (
    <BSTypeahead
      className={classNames(styles.typeahead, 'mt-2')}
      id='more-related'
      labelKey='value'
      onChange={(selected) => {
        router.push(selected[0])
        ref.current?.clear()
      }}
      options={related}
      placeholder={`More ${title}...`}
      ref={ref}
      renderMenu={(themes, menuProps) => (
        <Menu {...menuProps}>
          {themes.map(({ count, href, value }) => (
            <DropdownItem as={Link} href={href} key={href}>
              <div className={styles.item}>
                <span>
                  {value} ({count})
                </span>
              </div>
            </DropdownItem>
          ))}
        </Menu>
      )}
    />
  )
}

export default RelatedTypeahead
